export enum Experiments {
  MobileResponsiveNotifications = 'specs.chat.MobileResponsiveNotifications',
  ExpandInMobileResponsiveEditor = 'specs.chat.ExpandInMobileResponsiveEditor',
}
